// /var/www/lottobox-agent/plugins/axios.client.ts
import axios from 'axios'
import { useRuntimeConfig } from '#app'

// 手动从 Cookie 提取并解码 XSRF-TOKEN
function getXsrfToken(): string {
  if (typeof document === 'undefined') return ''
  const match = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]+)/)
  if (!match) return ''
  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const api = axios.create({
    baseURL: config.public.apiBase,
    withCredentials: true,
  })

  api.interceptors.request.use(
    (request) => {
      // 🌟 核心修复：手动拿到 Token 并强制塞进 Header，绕过 Axios 跨域不带 Token 的限制
      const xsrfToken = getXsrfToken()
      if (xsrfToken) {
        request.headers = request.headers || {}
        request.headers['X-XSRF-TOKEN'] = xsrfToken
      }

      // 自动把 /me → /agent/me（仅在 agent 子域下）
      const isAgent = typeof window !== 'undefined' && window.location.hostname.includes('agent.')
      const isExactMe = request.url?.endsWith('/me') && !request.url?.startsWith('/agent')

      if (isAgent && isExactMe) {
        request.url = '/agent/me'
      }

      return request
    },
    (error) => Promise.reject(error)
  )

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 419) {
        console.error('❌ CSRF Token Mismatch (419 Detected)')
      }
      return Promise.reject(error)
    }
  )

  return {
    provide: { api },
  }
})
